//=============================================
// ARCHELIOS MAP NAMESPACE
//=============================================

g_fNetConnectionPriceTTC = null;

/**
 * Ouvre la FAQ.
 * Fonction qui corrige la redirection sur une page vide sur Firefox (avec href="javascript:...").
 * @returns
 */
var openFaq = function() {
    $('#am-panel-modal-contents .close').click();
    setTimeout(function(){ $('#am-faq-link').click(); }, 500);
    return 0;
};

/**
 * Au clic sur un élement, on récupère le href-base pour ajouter l'URL de la page courante.
 * Le résultat est envoyé dans le href, pour réagir au clic.
 * @param o
 */
var fnGenerateGoFurtherMailTo = function(o) {
    var j = $(o);
    var sHrefBase = j.attr('href-base') || '';
    var sHref = sHrefBase;
    sHref = sHref.replace(';currentPageUrl;', encodeURIComponent(window.location.href));
    j.attr('href', sHref);
};

/**
 * Indique si une valeur est valide à afficher sur le rapport pdf (pas de tiret, pas de symbole infini...).
 * @param {} value La valeur à tester.
 * @returns boolean
 */
var fnIsValidValue = function(value) {
    return value != null
    && value != '&mdash;'
    && value != '∞'
    && isFinite(value.replace(/\s/g, ""));
};

var am = (function(module) {

    //Use strict mode
    'use strict';

    /**
     * 
     */
    module.InfoPanelController = function() {
        // Private attributes
        this._mainPanelView = undefined; // reference to the main view associated with the controller
        this._roofPanelView = undefined; // reference to the small side view associated with the controller
        this._mainController = undefined;
        this._map  = undefined; // reference to the map
        this._config = {
            displayRoofPanel: true,
            displayShareWithAdministation: false,
            suppressGoFurtherSection: false,
            minRoofSurfaceForWaitingModal: 500,
            displayPdfGuidesOnLastPage: false,
            displaySubtitlesOnLastPage: false,
            maxAllowedInstallationPower: 100,
            displaySentenceBelowSurfaceSlider: false,
            displayDiscoverBackgroundHeat: false,
            displayLinkForSelfConsumption: false,
            displaySubsidyIncludedForThermalResults: false,
            enableThermalSimulationForNonIndividuals: false,
            enableSelfConsumptionSimulationForNonIndividuals: false,
            enableEnedisFunctionality: false,
            displayHourlyCurveRadioButton: false,
            lastPanelPageEntries: {
                electricitySale: {
                    individual: 4,
                    professional: 4,
                    administration: 4
                },
                electricityAutoconsumption: {
                    individual: 4,
                    professional: 0,
                    administration: 0
                },
                hotWater: {
                    individual: 3,
                    professional: 0,
                    administration: 0
                }
            }
        };

        this._address = null;
        this._postal_code = null;
        this._locality = null;

        this._enedisProgressInterval = null;
 
        this._dataBindings = {
            dailyHotWaterProduction: {
                id: "dailyHotWaterProduction",
                unit: "L",
                precision: "0"
            },
            thermalPanelDailyHotWaterVolumeProduction: {
                id: "thermalPanelDailyHotWaterVolumeProduction",
                unit: "L",
                precision: "0"
            },
            thermalPanelAnnualHotWaterVolumeProduction: {
                id: "thermalPanelAnnualHotWaterVolumeProduction",
                unit: "m3PerYear",
                precision: "-1"
            },
            annualHeatProduction: {
                id: "annualHeatProduction",
                unit: "kWhPerYear",
                precision: "-1"
            },
            hotWaterProductionEquivalent: {
                id: "hotWaterProductionEquivalent",
                unit: "person",
                precision: "0"
            },
            maxAvailableRoof3DArea: {
                id: "maxAvailableRoof3DArea",
                unit: "m2",
                precision: "0"
            },
            annualElectricityProduction: {
                id: "annualElectricityProduction",
                unit: "kWhPerYear",
                precision: "-1"
            },
            annualElectricityConsumption: {
                id: "annualElectricityConsumption",
                unit: "kWhPerYear",
                precision: "-1"
            },
            electricityProductionEquivalent: {
                id: "electricityProductionEquivalent",
                unit: "person",
                precision: "0"
            },
            electricityConsumptionPerInhabitant: {
                id: "electricityConsumptionPerInhabitant",
                unit: "kWhPerYear",
                precision: "0"
            },
            pvAnnualCO2Savings: {
                id: "pvAnnualCO2Savings",
                unit: "kg",
                precision: "-1"
            },
            thermalPanelAnnualCO2Savings: {
                id: "thermalPanelAnnualCO2Savings",
                unit: "kg",
                precision: "-1"
            },
            pvAnnualCarKmSaved: {
                id: "pvAnnualCarKmSaved",
                unit: "km",
                precision: "-1"
            },
            thermalPanelAnnualCarKmSaved: {
                id: "thermalPanelAnnualCarKmSaved",
                unit: "km",
                precision: "-1"
            },
            electricalNetworkConnexionContraints: {
                id: "electricalNetworkConnexionContraints",
                unit: "-",
                precision: "0"
            },
            installPeakPower: {
                id: "installPeakPower",
                unit: "kWc",
                precision: "1"
            },

            /**
             * SALE AREA
             */
            pvElecSaleBorrow: {
                id: "pvElecSaleBorrow",
                unit: "spentCurrency",
                precision: "-1"
            },
            pvElecSaleBorrowedPercentage: {
                id: "pvElecSaleBorrowedPercentage",
                unit: "%",
                precision: "0"
            },
            pvElecSaleYearlyIncome: {
                id: "pvElecSaleYearlyIncome",
                unit: "currencyPerYear",
                precision: "-1"
            },
            pvElecSaleYearlyNetIncome: {
                id: "pvElecSaleYearlyNetIncome",
                unit: "currencyPerYear",
                precision: "-1"
            },
            pvElecSaleTotalIncome: {
                id: "pvElecSaleTotalIncome",
                unit: "currency",
                precision: "-1"
            },
            pvElecSaleInstallationCost: {
                id: "pvElecSaleInstallationCost",
                unit: "spentCurrency",
                precision: "-2"
            },
            pvElecSaleTotalProfits: {
                id: "pvElecSaleTotalProfits",
                unit: "currency",
                precision: "-1"
            },
            pvElecSaleYearlyProfits: {
                id: "pvElecSaleYearlyProfits",
                unit: "currencyPerYear",
                precision: "-1"
            },
            pvElecSaleYearlyRawProfits: {
                id: "pvElecSaleYearlyRawProfits",
                unit: "currencyPerYear",
                precision: "-1"
            },
            pvElecSaleYearlyOwnFunds: {
                id: "pvElecSaleYearlyOwnFunds",
                unit: "spentCurrencyPerYear",
                precision: "-1"
            },
            pvElecSaleYearlyCreditLoan: {
                id: "pvElecSaleYearlyCreditLoan",
                unit: "spentCurrencyPerYear",
                precision: "-1"
            },
            pvElecSaleYearlyMaintenance: {
                id: "pvElecSaleYearlyMaintenance",
                unit: "spentCurrencyPerYear",
                precision: "-1"
            },
            pvElecSaleReturnOnInvestment: {
                id: "pvElecSaleReturnOnInvestment",
                unit: "year",
                precision: "0"
            },
            pvElecSaleSubventions: {
                id: "pvElecSaleSubventions",
                unit: "currency",
                precision: "-1"
            },
            pvElecSaleTotalMaintenance: {
                id: "pvElecSaleTotalMaintenance",
                unit: "spentCurrency",
                precision: "-1"
            },
            pvElecSaleTotalCreditLoan: {
                id: "pvElecSaleTotalCreditLoan",
                unit: "spentCurrency",
                precision: "-1"
            },
            pvElecSaleOwnFunds: {
                id: "pvElecSaleOwnFunds",
                unit: "spentCurrency",
                precision: "-1"
            },
            pvElecSaleRaccordement: {
                id: "pvElecSaleRaccordement",
                unit: "spentCurrency",
                precision: "-1"
            },
            pvElecSaleInstallWoRaccordement: {
                id: "pvElecSaleInstallWoRaccordement",
                unit: "spentCurrency",
                precision: "-1"
            },
            electricityAutoproductionPercentage: {
                id: "electricityAutoproductionPercentage",
                unit: "%",
                precision: "0"
            },
            pvElecSaleObservationPeriod: {
                id: "pvElecSaleObservationPeriod",
                unit: "year",
                precision: "0"
            },
            pvElecSalePercentageOfReturn: {
                id: "pvElecSalePercentageOfReturn",
                unit: "%",
                precision: "1"
            },

            /**
             * AUTOCONSO AREA
             */
            pvAutoconsoInstallationCost: {
                id: "pvAutoconsoInstallationCost",
                unit: "spentCurrency",
                precision: "-2"
            },
            pvAutoconsoBorrowedPercentage: {
                id: "pvAutoconsoBorrowedPercentage",
                unit: "%",
                precision: "0"
            },
            pvAutoconsoBorrow: {
                id: "pvAutoconsoBorrow",
                unit: "spentCurrency",
                precision: "-2"
            },
            pvAutoconsoSavings: {
                id: "pvAutoconsoSavings",
                unit: "savedCurrencyPerYear",
                precision: "-1"
            },
            pvAutoconsoTotalSavings: {
                id: "pvAutoconsoTotalSavings",
                unit: "savedCurrency",
                precision: "-1"
            },
            pvAutoconsoIncome: {
                id: "pvAutoconsoIncome",
                unit: "currencyPerYear",
                precision: "-1"
            },
            pvAutoconsoTotalIncome: {
                id: "pvAutoconsoTotalIncome",
                unit: "currency",
                precision: "-1"
            },
            pvAutoconsoTotalProfits: {
                id: "pvAutoconsoTotalProfits",
                unit: "savedCurrency",
                precision: "-1"
            },
            pvAutoconsoReturnOnInvestment: {
                id: "pvAutoconsoReturnOnInvestment",
                unit: "year",
                precision: "0"
            },
            pvAutoconsoSubventions: {
                id: "pvAutoconsoSubventions",
                unit: "currency",
                precision: "-1"
            },
            pvAutoconsoTotalMaintenance: {
                id: "pvAutoconsoTotalMaintenance",
                unit: "spentCurrency",
                precision: "-1"
            },
            pvAutoconsoTotalCreditLoan: {
                id: "pvAutoconsoTotalCreditLoan",
                unit: "spentCurrency",
                precision: "-1"
            },
            pvAutoconsoOwnFunds: {
                id: "pvAutoconsoOwnFunds",
                unit: "spentCurrency",
                precision: "-1"
            },
            pvAutoconsoRaccordement: {
                id: "pvAutoconsoRaccordement",
                unit: "spentCurrency",
                precision: "-1"
            },
            pvAutoconsoInstallWoRaccordement: {
                id: "pvAutoconsoInstallWoRaccordement",
                unit: "spentCurrency",
                precision: "-1"
            },
            pvAutoconsoYearlyIncome: {
                id: "pvAutoconsoYearlyIncome",
                unit: "currencyPerYear",
                precision: "-1"
            },
            pvAutoconsoYearlyNetIncome: {
                id: "pvAutoconsoYearlyNetIncome",
                unit: "currencyPerYear",
                precision: "-1"
            },
            pvAutoconsoYearlySavings: {
                id: "pvAutoconsoYearlySavings",
                unit: "savedCurrencyPerYear",
                precision: "-1"
            },
            pvAutoconsoYearlyNetSavings: {
                id: "pvAutoconsoYearlyNetSavings",
                unit: "savedCurrencyPerYear",
                precision: "-1"
            },
            pvAutoconsoYearlyNetSavingsPlusIncome: {
                id: "pvAutoconsoYearlyNetSavingsPlusIncome",
                unit: "savedCurrencyPerYear",
                precision: "-1"
            },
            pvAutoconsoYearlyProfits: {
                id: "pvAutoconsoYearlyProfits",
                unit: "savedCurrencyPerYear",
                precision: "-1"
            },
            pvAutoconsoYearlyNetProfits: {
                id: "pvAutoconsoYearlyNetProfits",
                unit: "savedCurrencyPerYear",
                precision: "-1"
            },
            pvAutoconsoYearlyRawProfits: {
                id: "pvAutoconsoYearlyRawProfits",
                unit: "savedCurrencyPerYear",
                precision: "-1"
            },
            pvAutoconsoYearlyOwnFunds: {
                id: "pvAutoconsoYearlyOwnFunds",
                unit: "spentCurrencyPerYear",
                precision: "-1"
            },
            pvAutoconsoYearlyCreditLoan: {
                id: "pvAutoconsoYearlyCreditLoan",
                unit: "spentCurrencyPerYear",
                precision: "-1"
            },
            pvAutoconsoYearlyMaintenance: {
                id: "pvAutoconsoYearlyMaintenance",
                unit: "spentCurrencyPerYear",
                precision: "-1"
            },
            pvAutoconsoObservationPeriod: {
                id: "pvAutoconsoObservationPeriod",
                unit: "year",
                precision: "0"
            },
            pvAutoconsoPercentageOfReturn: {
                id: "pvAutoconsoPercentageOfReturn",
                unit: "%",
                precision: "1"
            },
            
            /**
             * THERMAL PANEL AREA
             */
            thermalPanelSurface: {
                id: "thermalPanelSurface",
                unit: "m2",
                precision: "0"
            },
            thermalPanelAnnualNeedsCoveragePercentage: {
                id: "thermalPanelAnnualNeedsCoveragePercentage",
                unit: "%",
                precision: "0"
            },
            thermalPanelInstallationCost: {
                id: "thermalPanelInstallationCost",
                unit: "spentCurrency",
                precision: "-2"
            },
            thermalPanelRawInstallationCost: {
                id: "thermalPanelRawInstallationCost",
                unit: "spentCurrency",
                precision: "-2"
            },
            thermalPanelSubventions: {
                id: "thermalPanelSubventions",
                unit: "currency",
                precision: "-1"
            },
            thermalTotalMaintenance: {
                id: "thermalTotalMaintenance",
                unit: "spentCurrency",
                precision: "-1"
            },
            thermalTotalCreditLoan: {
                id: "thermalTotalCreditLoan",
                unit: "spentCurrency",
                precision: "-1"
            },
            thermalPanelOwnFunds: {
                id: "thermalPanelOwnFunds",
                unit: "spentCurrency",
                precision: "-1"
            },
            thermalPanelBorrow: {
                id: "thermalPanelBorrow",
                unit: "spentCurrency",
                precision: "-1"
            },
            thermalPanelBorrowedPercentage: {
                id: "thermalPanelBorrowedPercentage",
                unit: "%",
                precision: "0"
            },
            thermalPanelReturnOnInvestment: {
                id: "thermalPanelReturnOnInvestment",
                unit: "year",
                precision: "0"
            },
			thermalPanelYearlySavings: {
                id: "thermalPanelYearlySavings",
                unit: "savedCurrencyPerYear",
                precision: "-1"
            },
            thermalPanelYearlyNetSavings: {
                id: "thermalPanelYearlyNetSavings",
                unit: "savedCurrencyPerYear",
                precision: "-1"
            },
            thermalPanelTotalBillSavings: {
                id: "thermalPanelTotalBillSavings",
                unit: "savedCurrency",
                precision: "-1"
            },
            thermalPanelTotalSavings: {
                id: "thermalPanelTotalSavings",
                unit: "savedCurrency",
                precision: "-1"
            },
            thermalPanelTotalSpendings: {
                id: "thermalPanelTotalSpendings",
                unit: "spentCurrency",
                precision: "-1"
            },
            thermalPanelTotalMaintenance: {
                id: "thermalPanelTotalMaintenance",
                unit: "spentCurrency",
                precision: "-1"
            },
            thermalPanelTotalCreditLoan: {
                id: "thermalPanelTotalCreditLoan",
                unit: "spentCurrency",
                precision: "-1"
            },
            thermalPanelTotalCreditCost: {
                id: "thermalPanelTotalCreditCost",
                unit: "spentCurrency",
                precision: "-1"
            },
            thermalPanelTotalProfits: {
                id: "thermalPanelTotalProfits",
                unit: "savedCurrency",
                precision: "-1"
            },
            thermalPanelRawTotalProfits: {
                id: "thermalPanelRawTotalProfits",
                unit: "savedCurrency",
                precision: "-1"
            },
            thermalPanelYearlyIncome: {
                id: "thermalPanelYearlyIncome",
                unit: "currencyPerYear",
                precision: "-1"
            },
            thermalPanelYearlyNetIncome: {
                id: "thermalPanelYearlyNetIncome",
                unit: "currencyPerYear",
                precision: "-1"
            },
            thermalPanelYearlyProfits: {
                id: "thermalPanelYearlyProfits",
                unit: "savedCurrencyPerYear",
                precision: "-1"
            },
            thermalPanelYearlyOwnFunds: {
                id: "thermalPanelYearlyOwnFunds",
                unit: "spentCurrencyPerYear",
                precision: "-1"
            },
            thermalPanelYearlyRawProfits: {
                id: "thermalPanelYearlyRawProfits",
                unit: "savedCurrencyPerYear",
                precision: "-1"
            },
            thermalPanelYearlyCreditLoan: {
                id: "thermalPanelYearlyCreditLoan",
                unit: "spentCurrencyPerYear",
                precision: "-1"
            },
            thermalPanelYearlySpendings: {
                id: "thermalPanelYearlySpendings",
                unit: "spentCurrencyPerYear",
                precision: "-1"
            },
            thermalPanelYearlyMaintenance: {
                id: "thermalPanelYearlyMaintenance",
                unit: "spentCurrencyPerYear",
                precision: "-1"
            },
            thermalPanelYearlyInvestment: {
                id: "thermalPanelYearlyInvestment",
                unit: "spentCurrencyPerYear",
                precision: "-1"
            },
            thermalPanelObservationPeriod: {
                id: "thermalPanelObservationPeriod",
                unit: "year",
                precision: "0"
            },
            thermalPanelPercentageOfReturn: {
                id: "thermalPanelPercentageOfReturn",
                unit: "%",
                precision: "1"
            },
            
            /**
             * COMBINED PANEL AREA
             */
			combinedPanelSurface: {// #2963
                id: "combinedPanelSurface",
                unit: "m2",
                precision: "0"
            },
            combinedAnnualHotWaterNeedsCoverageRate: {// #2963
                id: "combinedAnnualHotWaterNeedsCoverageRate",
                unit: "%",
                precision: "0"
            },
            combinedAnnualHeatNeedsCoverageRate: {// #2963
                id: "combinedAnnualHeatNeedsCoverageRate",
                unit: "%",
                precision: "0"
            },
            combinedInstallationCost: {// #2963
                id: "combinedInstallationCost",
                unit: "spentCurrency",
                precision: "-2"
            },
            combinedRawInstallationCost: {// #2963
                id: "combinedRawInstallationCost",
                unit: "spentCurrency",
                precision: "-2"
            },
            combinedSubventions: {
                id: "combinedSubventions",
                unit: "currency",
                precision: "-1"
            },
            combinedTotalMaintenance: {
                id: "combinedTotalMaintenance",
                unit: "spentCurrency",
                precision: "-1"
            },
            combinedTotalCreditLoan: {
                id: "combinedTotalCreditLoan",
                unit: "spentCurrency",
                precision: "-1"
            },
            combinedOwnFunds: {
                id: "combinedOwnFunds",
                unit: "spentCurrency",
                precision: "-1"
            },
            combinedBorrow: {// #2963
                id: "combinedBorrow",
                unit: "spentCurrency",
                precision: "-1"
            },
            combinedBorrowedPercentage: {// #2963
                id: "combinedBorrowedPercentage",
                unit: "%",
                precision: "0"
            },
            combinedYearlySavings: {// #2963
                id: "combinedYearlySavings",
                unit: "savedCurrencyPerYear",
                precision: "-1"
            },
            combinedYearlyNetSavings: {
                id: "combinedYearlyNetSavings",
                unit: "savedCurrencyPerYear",
                precision: "-1"
            },
            combinedTotalSavings: {// #2963
                id: "combinedTotalSavings",
                unit: "savedCurrency",
                precision: "-1"
            },
            combinedTotalProfits: {// #2963
                id: "combinedTotalProfits",
                unit: "savedCurrency",
                precision: "-1"
            },
            combinedReturnOnInvestment: {// #2963
                id: "combinedReturnOnInvestment",
                unit: "year",
                precision: "0"
            },
            combinedYearlyIncome: {
                id: "combinedYearlyIncome",
                unit: "currencyPerYear",
                precision: "-1"
            },

            combinedYearlyNetIncome: {
                id: "combinedYearlyNetIncome",
                unit: "currencyPerYear",
                precision: "-1"
            },
            combinedYearlyProfits: {
                id: "combinedYearlyProfits",
                unit: "savedCurrencyPerYear",
                precision: "-1"
            },
            combinedYearlyRawProfits: {
                id: "combinedYearlyRawProfits",
                unit: "savedCurrencyPerYear",
                precision: "-1"
            },
            combinedYearlyOwnFunds: {
                id: "combinedYearlyOwnFunds",
                unit: "spentCurrencyPerYear",
                precision: "-1"
            },
            combinedYearlyCreditLoan: {
                id: "combinedYearlyCreditLoan",
                unit: "spentCurrencyPerYear",
                precision: "-1"
            },
            combinedYearlySpendings: {
                id: "combinedYearlySpendings",
                unit: "spentCurrencyPerYear",
                precision: "-1"
            },
            combinedYearlyMaintenance: {
                id: "combinedYearlyMaintenance",
                unit: "spentCurrencyPerYear",
                precision: "-1"
            },
            combinedYearlyInvestment: {
                id: "combinedYearlyInvestment",
                unit: "spentCurrencyPerYear",
                precision: "-1"
            },
            combinedObservationPeriod: {
                id: "combinedObservationPeriod",
                unit: "year",
                precision: "0"
            },
            combinedPercentageOfReturn: {
                id: "combinedPercentageOfReturn",
                unit: "%",
                precision: "1"
            },

            optimalSurfaceForElectricitySale: {
                id: "optimalSurfaceForElectricitySale",
                unit: "m2",
                precision: "0"
            },
            optimalPeakPowerForElectricitySale: {
                id: "optimalPeakPowerForElectricitySale",
                unit: "kWc",
                precision: "1"
            },
            optimalSurfaceForAutoconsumption : {
                id: "optimalSurfaceForAutoconsumption",
                unit: "m2",
                precision: "0"
            },
            optimalPeakPowerForAutoconsumption : {
                id: "optimalPeakPowerForAutoconsumption",
                unit: "kWc",
                precision: "1"
            }
        };

        this._handleFormChange = undefined;
        this._handlePageChange = undefined;
        this._updateCheckbox = undefined;
        this._enedisShowMoreInfoTip = undefined;
        this._closePanel = undefined;
        this._irradiationClasses = [];
    };

    module.InfoPanelController.prototype.init = function(mainController, config) {
        this._mainController = mainController;

        var appConfig = mainController.getConfig();
        var irradiationClasses = am.utils.getIrradClasses(appConfig);
        var maxReturnOnInvestment = (appConfig.maxReturnOnInvestment === undefined) ? 20 : appConfig.maxReturnOnInvestment;
        
        // Instantiate the private attributes
        this._config = am.utils.mergeObjects(this._config, config);
        this._address = mainController.address;
        this._postal_code = mainController.postal_code;
        this._locality = mainController.locality;

        this._config.projectId = appConfig.projectId;

        this._map  = mainController.getMapObject();
        this._irradiationClasses = irradiationClasses;
        this._mainPanelView = am.utils.infoPanelView({
            anchor: 'lower-right',
            autoPan: false,
            customCssClass: 'am-main-panel',
            templateParameters: {
                irradiationClasses: irradiationClasses,
                lastPageEntries: this._config.lastPanelPageEntries,
                addShareButton: this._config.displayShareWithAdministation,
                showMessageBelowEconomicalResults: this._config.displayMessageBelowEconomicalResults,
                displayResultsSentencePrefix: this._config.displayResultsSentencePrefix,
                suppressGoFurtherSection: this._config.suppressGoFurtherSection,
                displayPDFGuidesOnLastPage: this._config.displayPdfGuidesOnLastPage,
                displaySubtitlesOnLastPage: this._config.displaySubtitlesOnLastPage,
                displaySentenceBelowSurfaceSlider: this._config.displaySentenceBelowSurfaceSlider,
                displayDiscoverBackgroundHeat: this._config.displayDiscoverBackgroundHeat,
                displayLinkForSelfConsumption: this._config.displayLinkForSelfConsumption,
                displaySubsidyIncludedForThermalResults: this._config.displaySubsidyIncludedForThermalResults,
                enableThermalSimulationForNonIndividuals: this._config.enableThermalSimulationForNonIndividuals,
                enableSelfConsumptionSimulationForNonIndividuals: this._config.enableSelfConsumptionSimulationForNonIndividuals,
                enableEnedisFunctionality: this._config.enableEnedisFunctionality,
                displayHourlyCurveRadioButton: this._config.displayHourlyCurveRadioButton
            },
            maxROIForProfitability: maxReturnOnInvestment
        }).addTo(this._map);
        if (this._config.displayRoofPanel) {
            this._roofPanelView = am.utils.panelView({
                anchor: 'lower-left',
                autoPan: false,
                customCssClass: 'am-roof-info-panel'
            }).addTo(this._map);
        }

        // Register event handlers associated with the main panel view
        this._initializeMainPanelView();

        // Populate the small side panel displaying information on the selected roof (surface, potential, etc.) and attach event handlers to it
        this._initializeRoofPanelView();

        // Register event handlers associated with the panel
        am.eventManager.register('display_info_on_feature', this._displayInfoOnFeature, this);
        am.eventManager.register('feature_selection_changed', this._updateSlider, this);
        am.eventManager.register('hide_feature_info', this._hideFeatureInfo, this);
        am.eventManager.register('roof_irradiation_computation_started', this._handleComputationStart, this);
        am.eventManager.register('roof_irradiation_computation_ended', this._handleComputationEnd, this);
        am.eventManager.register('address_search_field_updated', this._setAddress, this);
    };

    module.InfoPanelController.prototype.destroy = function() {
        // Remove panel from the map
        this._mainPanelView.remove();
        this._map = undefined;

        // Remove event handlers associated with the view
        var _this = this;
        this._mainPanelView.getPanel().then(function(panelElement) {
            panelElement.find('.input, .checkbox').off('click tap', _this._updateCheckbox);
            panelElement.find('input').off('change', _this._handleFormChange);
            panelElement.find('a.btn, button:not(.btn-close)').off('click tap', _this._handlePageChange);
            panelElement.find('.am-solar-panel-surface-slider').off('slide change', _this._handleFormChange);
            panelElement.find('.am-solar-panel-surface-slider').off('slide change', _this._limitSliderRange);
            panelElement.find('.am-solar-panel-surface-slider').off('slide change', _this._displayWaitModal);
            panelElement.find('.btn-close').off('click tap', _this._closePanel);
            panelElement.find('.btn[data-action="share-project"]').off('click tap', _this._displayShareModal);
            panelElement.find('.btn[data-action="export-pdf"]').off('click tap', _this._exportToPdf);
            panelElement.find('#am-user-profiles label').off('click tap', _this._toggleSimulationButtons);
            panelElement.find('.btn-enedis').off('click tap', _this._enedisRequestSimu);
            panelElement.find('.enedis-more-info-link').off('click tap', _this._enedisShowMoreInfoTip);

            panelElement.find('.am-enedis-info-panel-btn').off('click tap', _this._toggleEnedisPanel);
        });

        // Remove event handlers associated with the panel
        am.eventManager.unregister('knob_changed', this._handleFormChange, this);
        am.eventManager.unregister('display_info_on_feature', this._displayInfoOnFeature, this);
        am.eventManager.unregister('feature_selection_changed', this._updateSlider, this);
        am.eventManager.unregister('hide_feature_info', this._hideFeatureInfo, this);
        am.eventManager.unregister('address_search_field_updated', this._setAddress, this);
    };

    module.InfoPanelController.prototype._initializeMainPanelView = function() {
        var _this = this;
        this._mainPanelView.getPanelElement().then(function(panelElement) {
            // Define the function called to synchronize the form elements (if one element is changed, the same 
            // elements in the other forms are set to the same value; this is also true for the sliders)
            _this._handleFormChange = function(event) {

                return new Promise(function(resolve, reject) {
                    // Synchronize the various form elements
                    if (event.type == "knob_changed") {
                        resolve();
                    } else {
                        var $target = $(event.target).closest('.am-user-input').find('input');
                        if ($target.attr('data-provide') == 'slider') { // slider
                            if ($target.attr('name') !== 'thermalPanelSurface') {
                                _this._mainPanelView.getSliderElements().then(function (sliders) {
                                    sliders.forEach(function (slider) {
                                        if (slider.installationType === 'pv') { // exclude the thermal slider (if any)
                                            slider.bootstrapSlider('setValue', $target.val(), false, false);
                                            slider.updatePeakPower();
                                            slider.bootstrapSlider('relayout');
                                        }
                                    });
                                    $(".enedis_request_form").show();
                                    $(".enedis_request_form_results").hide();
                                    g_fNetConnectionPriceTTC = null;
                                    if (_this._enedisProgressInterval != null){
                                        clearInterval(_this._enedisProgressInterval);
                                        _this._enedisProgressInterval = null;
                                    }
                                    if (
                                        (am.solarInstallationModel._pvPanelModel._properties.installPeakPower * 1e-3) 
                                        > (250*1/0.85))
                                    {
                                        $(".enedis_infopanel_desc").hide();
                                        $(".enedisInfoPanelBtn").hide();
                                        $(".enedis_infopanel_desc_above_max_kva").show();
                                        $(".enedis-select-triphase-container").hide();
                                    }
                                    else {
                                        $(".enedis_infopanel_desc").show();
                                        $(".enedisInfoPanelBtn").show();
                                        $(".enedis_infopanel_desc_above_max_kva").hide();
                                        $(".enedis-select-triphase-container").show();
                                        $(".parametric").hide();
                                    }
                                    resolve();
                                });
                            } else {
                                resolve();
                            }
                        } else { // number or checkbox
                            var targetType = $target.attr('type');
                            var targetName = $target.attr('name');
                            var sameElementsSelector = 'input[type="' + targetType + '"][name="' + targetName + '"]';
                            var $sameElements = panelElement.find(sameElementsSelector);
                            if (targetType == 'checkbox') {
                                $sameElements.prop('checked', $target.prop('checked'));
                                if ($target.attr('checked') && ($target.attr('checked') == 'checked')) {
                                    $sameElements.attr('checked', 'checked');
                                } else {
                                    $sameElements.removeAttr('checked');
                                }
                            } else if (targetType == 'number') {
                                $sameElements.val($target.val());
                            } else if (targetType === 'radio') {
                                $target = $target.filter(':checked');
                                var $hourlyCurveButton = $('#am-elec-consumption-file'); // bouton permettant de téléverser la courbe de charge
                                if (targetName === 'userCategory') {
                                    $('[data-contact-user-type]').attr('data-contact-user-type', $target.val());
                                    $hourlyCurveButton.val(''); // réinitialisation du bouton permettant de téléverser la courbe de charge
                                } else if (targetName === 'elecConsumptionInfo') {
                                    var value = $target.val();
                                    var hourlyCurveFile = $hourlyCurveButton.val();
                                    $('#btn_am-electricity-autoconsumption-results-section').prop('disabled', value === 'hourlyCurve' && !hourlyCurveFile);
                                }
                            }
                            resolve();
                        }
                    }
                }).then(function(res) {
                    return _this._updateResults();
                }).then(function (res) {
					var $target = $(event.target).closest('.am-user-input').find('input');
					var targetName = $target.attr('name');
					if(targetName=="thermalType")// #2963
                        _this._mainPanelView.updateThermalView($target.val());
                    // Send en event to notify the main controller that the address displayed in the browser navigation bar
                    // should be changed
                    am.eventManager.trigger('update_url', _this._getPageUrl());
                }); // #2381
            }

            // Define the function changing the current page after the user has clicked on a link button
            _this._handlePageChange = function(event) {
                // Change the current page
                var $target = $(event.target).closest('button');
                var newPageId = $target.attr('data-target');
                var oldPageId = _this._mainPanelView.getCurrentPageId();
                if (newPageId) {
                    var userInputs = _this._mainPanelView.getUserInputs();
                    if (newPageId == "am-electricity-autoconsumption-results-section") {
                        $(".enedis-select-triphase-container").show();
                    }
                    if(oldPageId=="am-electricity-info-section"){ //#135 on redefinie la valeur panelSurface a chaque navigation de page 
                        am.solarInstallationModel.getResults()
                        .then(function(results){
                            userInputs.panelSurface = results.optimalSurfaceForElectricitySale;
                            if(newPageId=="am-electricity-autoconsumption-results-section" || newPageId=="am-autoconsumption-info-section"){
                                userInputs.panelSurface = results.optimalSurfaceForAutoconsumption;
                            }

                            $(".enedis_request_form").show();
                            $(".enedis_request_form_results").hide();
                            g_fNetConnectionPriceTTC = null;
                            if (_this._enedisProgressInterval != null) {
                                clearInterval(_this._enedisProgressInterval);
                                _this._enedisProgressInterval = null;
                            }
                            $('.enedisInfoPanelBtn-parametric').hide();
                            return  _this._mainPanelView.setUserInputs(userInputs)
                        })
                        .then(function () {
                            return _this._updateResults()
                        })
                        .then(function() {
                            _this._mainPanelView.displayPage(newPageId);
                        });
                    }
                    else{
                        _this._mainPanelView.displayPage(newPageId);
                    }            
                }

                // Send en event to notify the main controller that the address displayed in the browser navigation bar
                // should be changed
                am.eventManager.trigger('update_url', _this._getPageUrl(oldPageId, newPageId));
                am.eventManager.trigger('tracking_click', $target[0].id); // #2747 suivi des clics, on envoie l'id du bouton cliqué

            };

            // Update the input checkboxes when the user clicks on the associated div
            _this._updateCheckbox = function(event) {
                event.preventDefault();
                if ($(this).hasClass('checkbox')) {
                    var $input = $(this).find('input');
                    $input.prop('checked', !$input.prop('checked'));
                    if ($input.attr('checked') && ($input.attr('checked') == 'checked')) {
                        $input.removeAttr('checked');
                    } else {
                        $input.attr('checked', 'checked');
                    }
                    event.target = $input.get(0);
                }
                _this._handleFormChange(event);
            };

            // Close panel
            _this._closePanel = function(event) {
                _this._hideFeatureInfo();
                am.eventManager.trigger('clear_feature_selection');
            };

            // Disable thermal simulation and autoconsumption buttons in the case of a professional or an administration
            _this._toggleSimulationButtons = function(event) {
                // Get the radio button on which the user clicked 
                var $input = $(event.target).closest('label').find('input');
                var choice = $input.attr('value');

                // Handle the display of the right content depending on the user type (individual, professional, administration)
                $(event.target).closest('.page').find('.update-trans').each(function() {
                    // Show the right content and hide the others
                    $( this ).find( '[data-trans-type]:not([data-trans-type~="' + choice + '"])').addClass('hidden');
                    $( this ).find( '[data-trans-type~="' + choice + '"]').removeClass('hidden');
                });
                var $pageContents = $(event.target).closest('.page-content');
                $pageContents.animate({ scrollTop: $pageContents.outerHeight() }, 800); // scroll smoothly to the bottom of the page

                // (De)activate the buttons
                var buttons = [$('#btn_am-hot-water-info-section'), $('#btn_am-autoconsumption-info-section')];
                if (_this._config.enableThermalSimulationForNonIndividuals) {
                    buttons.shift();
                }
                if (_this._config.enableSelfConsumptionSimulationForNonIndividuals) {
                    buttons.pop();
                }
                if (choice === "individual") {
                    buttons.forEach(function($button) {
                        $button.prop('disabled', false);
                    });
                    var $radioButton = $('#am-elec-consumption').find('input[type=radio][value=unknown]');
                    $radioButton.prop('checked', true);
                    $radioButton.trigger('change');
                } else { // professional or administration
                    buttons.forEach(function($button) {
                        $button.prop('disabled', true);
                    });
                    if (_this._config.enableSelfConsumptionSimulationForNonIndividuals) {
                        var $radioButton = $('#am-elec-consumption').find('input[type=radio][value=hourlyCurve]');
                        $radioButton.prop('checked', true);
                        $radioButton.trigger('change');
                    }
                }
            };


            _this._toogleEnedisProgressBar = function (b) {
                _this._enedisResetProgressBar();
                if (b) {
                    $(".enedis_spinner").hide();
                    $(".enedis_progress").show();
                    $(".enedisInfoPanelBtn").hide();
                }
                else {
                    $(".enedis_spinner").hide();
                    $(".enedis_progress").hide();
                    $(".enedisInfoPanelBtn").show();
                }
                $(".enedis-select-triphase-container").hide();
            };

            _this._enedisSubstituteVars = function (sHtml, oRes) {
                sHtml = sHtml.replace(
                    "{{enedis_cost}}",
                    (oRes.hasOwnProperty("connection_cost") ? (am.translator.formatNumber(oRes["connection_cost"], 0)) : "")
                );
                sHtml = sHtml.replace(
                    "{{enedis_length}}",
                    (oRes.hasOwnProperty("connection_length") ? (am.translator.formatNumber(oRes["connection_length"], 0)) : "")
                );
                sHtml = sHtml.replace(
                    "{{enedis_peak_power}}",
                    (oRes.hasOwnProperty("adapted_power") ? (am.translator.formatNumber(oRes["adapted_power"] * 1. / 0.85, 1)) : "")
                );
                sHtml = sHtml.replace(
                    "{{enedis_area}}",
                    (
                        oRes.hasOwnProperty("adapted_power") ?
                            (
                                am.translator.formatNumber(oRes["adapted_power"] *
                                    1. / 0.85 *
                                    1 / (_this._mainPanelView.options.pvPanelYield), 0)
                            ) :
                            ""
                    )
                );
                //_this._mainPanelView.options.pvPanelYield
                return sHtml;
            };

            _this._enedisPopulateResultDiv = function (oRes) {
                g_fNetConnectionPriceTTC = null;

                if (_this._enedisProgressInterval != null) {
                    clearInterval(_this._enedisProgressInterval);
                    _this._enedisProgressInterval = null;
                }

                $('.enedisInfoPanelBtn-parametric').hide();

                var sHtml = "";
                if (oRes == null) {
                    sHtml = am.translator.translate("enedis_Err_desc");
                }
                else if (oRes["result_code"]) {
                    if (oRes.hasOwnProperty("tried_to_adapt_power") && oRes["tried_to_adapt_power"]) {
                        if (oRes["has_adapted_power"]) {
                            /** {{enedis_peak_power}} with adapted_power */
                            sHtml = am.translator.translate("enedis_bt_result_parametrics");
                        }
                        else {
                            sHtml = am.translator.translate("enedis_bt_result_parametrics_no_result");
                        }
                        //$('.parametric').hide();
                    }
                    else {
                        switch (oRes["result_code"]) {
                            case "OutOfEnedisZone":
                                sHtml = am.translator.translate("enedis_bt_outofenediszone");
                                break;
                            case "TooFarFromGrid":
                                sHtml = am.translator.translate("enedis_bt_toofarfromgrid_part1");
                                sHtml += "<br/>";
                                sHtml += am.translator.translate("enedis_bt_toofarfromgrid_part2");
                                sHtml += "<br/>";
                                sHtml += am.translator.translate("enedis_bt_toofarfromgrid_part3");
                                break;
                            case "LVGridWorks":
                                /** {{enedis_length}} with connection_length */
                                sHtml = am.translator.translate("enedis_bt_lvgridworks_part1");
                                sHtml += "<br/>";
                                sHtml += am.translator.translate("enedis_bt_lvgridworks_part2");
                                sHtml += "<br/>";
                                sHtml += am.translator.translate("enedis_bt_lvgridworks_part3");
                                $('.enedisInfoPanelBtn-parametric').show();
                                break;
                            case "LVLongConnection":
                                sHtml = am.translator.translate("enedis_Plein_desc");
                                if (oRes.hasOwnProperty("cost")) {
                                    switch (oRes["cost"]["status"]) {
                                        case "Estimated":
                                            /** {{enedis_cost}}=>fixed_part/linear_part & {{enedis_length}}=>connection_length */
                                            sHtml = am.translator.translate("enedis_bt_lvlongconnection_estimated_part1");
                                            sHtml += "<br/><br/><table><tr><td><i class='am-icon am-info-bubble-icon' style='width: 32px; height: 32px;'></i>&nbsp;</td>";
                                            sHtml += ("<td>" + am.translator.translate("enedis_bt_lvlongconnection_estimated_part2") + "</td>");
                                            sHtml += "</tr></table>";
                                            oRes["connection_cost"] = oRes["cost"]["fixed_part"] + oRes["cost"]["linear_part"];
                                            break;
                                        case "QuoteNeeded":
                                            /** {{enedis_length}} with connection_length */
                                            sHtml = am.translator.translate("enedis_bt_lvlongconnection_quoteneeded_part1");
                                            sHtml += "<br/>";
                                            sHtml += am.translator.translate("enedis_bt_lvlongconnection_quoteneeded_part2");
                                            sHtml += "<br/>";
                                            sHtml += am.translator.translate("enedis_bt_lvlongconnection_quoteneeded_part3");
                                            //$('.parametric').show();
                                            break;
                                        default: break;
                                    }
                                }
                                break;
                            case "ShortConnection":
                                switch (oRes["cost"]["status"]) {
                                    case "Estimated":
                                        /** {{enedis_cost}} by fixed_part/linear_part & {{enedis_length}} by connection_length */
                                        sHtml = am.translator.translate("enedis_bt_shortconnection_estimated_part1");
                                        sHtml += "<br/><br/><table><tr><td><i class='am-icon am-info-bubble-icon' style='width: 32px; height: 32px;'></i>&nbsp;</td>";
                                        sHtml += ("<td>" + am.translator.translate("enedis_bt_shortconnection_estimated_part2") + "</td>");
                                        sHtml += "</tr></table>";
                                        oRes["connection_cost"] = oRes["cost"]["fixed_part"] + oRes["cost"]["linear_part"];
                                        break;
                                    case "QuoteNeeded":
                                        /** {{enedis_length}} with connection_length */
                                        sHtml = am.translator.translate("enedis_bt_shortconnection_quoteneeded_part1");
                                        sHtml += "<br/>";
                                        sHtml += am.translator.translate("enedis_bt_shortconnection_quoteneeded_part2");
                                        sHtml += "<br/>";
                                        sHtml += am.translator.translate("enedis_bt_shortconnection_quoteneeded_part3");
                                        //$('.parametric').show();
                                        break;
                                    default: break;
                                }
                                break;
                            default:
                                sHtml = am.translator.translate("enedis_Err_desc");
                                break;
                        }
                    }
                    sHtml = this._enedisSubstituteVars(sHtml, oRes);

                    if (oRes["connection_cost"] != null) {
                        g_fNetConnectionPriceTTC = oRes["connection_cost"];
                        sHtml = sHtml.replace(/none;/, "block;");
                    } else {
                        sHtml = sHtml.replace(/none;/g, "block;");
                        sHtml = sHtml.replace(/block;/, "none;");
                    }
                }
                else {
                    sHtml = am.translator.translate("enedis_Err_desc");
                }
                sHtml = ("<p>" + sHtml + "</p>")
                $(".enedis_request_form_results_data").html(sHtml);
                $(".enedis_request_form").hide();
                $(".enedis_request_form_results").show();

                this._updateResults();
            };

            _this._enedisUpdateParamsSimu = function (oRes) {
                $.ajax({
                    type: "POST",
                    data: {
                        "getInfos": 'Enedis_updateSiteInfo',
                        "version_enedis": "v3",
                        "feature_id": _this._featureId,
                        "enedis_dist": (oRes.hasOwnProperty("connection_length") ? oRes["connection_length"] : ""),
                        "enedis_cost": (oRes.hasOwnProperty("connection_cost") ? oRes["connection_cost"] : ""),
                        "enedis_code": oRes["result_code"],
                        "enedis_power": (
                            oRes.hasOwnProperty("cost") && oRes["cost"].hasOwnProperty("adapted_power") ?
                                oRes["cost"]["adapted_power"] :
                                ""
                        ),
                        "cyth_cost": am.solarInstallationModel._pvPanelModel._properties.economicsResults['sale'].electricityConnectionCostOverPeriod
                    },
                    url: "/backend/getInfosBDD.php",
                    dataType: 'json',
                    error: function () { },
                    success: function () { }
                });
            };

            _this._enedisResetProgressBar = function () {
                $('.enedis_progress .progress-bar').attr('aria-valuemin', 0);
                $('.enedis_progress .progress-bar').attr('aria-valuemax', 20);
                $('.enedis_progress .progress-bar').attr('aria-valuenow', 0).css('width', '0%');
                $('.enedis_progress .progress-bar').html('0');
                if (_this._enedisProgressInterval != null) {
                    clearInterval(_this._enedisProgressInterval);
                    _this._enedisProgressInterval = null;
                }
            };

            _this._enedisUpdateProgressBarRange = function (fReqMax) {
                $('.enedis_progress .progress-bar').attr('aria-valuemin', 0);
                $('.enedis_progress .progress-bar').attr('aria-valuemax', Math.ceil(fReqMax));
            };

            _this._enedisUpdateProgressBar = function () {
                var nNextVal = Math.ceil(parseFloat($('.enedis_progress .progress-bar').attr('aria-valuenow'))) + 1,
                    //nCurRate = parseInt($('.enedis_progress .progress-bar').css('width').replace('%','')),
                    nNextRate = Math.ceil(nNextVal * 100 / $('.enedis_progress .progress-bar').attr('aria-valuemax'));

                if (nNextRate > 100) {
                    nNextRate = 100;
                }

                $('.enedis_progress .progress-bar').attr('aria-valuenow', nNextVal).css('width', nNextRate + '%');
                $('.enedis_progress .progress-bar').html("");
            };

            _this._enedisShowMoreInfoTip = function (event) {
                var $infoBubble = $(event.currentTarget),
                    modalType = $infoBubble.attr('data-subject');
                if (modalType) {
                    am.templateManager.getTemplateAsText('panel-modal', { modalType: modalType }).then(function (panelString) {
                        var $panel = $('#am-panel-modal');
                        $panel.html(panelString);
                        $panel.find("#am-panel-modal-contents").modal({
                            backdrop: 'static',
                            show: true
                        });
                    });
                }
            };

            _this._toggleEnedisPanel = function (event) {
                $(".enedisInfoPanelData").toggle();
                if ($(".enedisInfoPanelData").css('display') === 'none') {
                    $('.am-enedis-info-panel-btn>span').removeAttr('class').attr('class', 'glyphicon glyphicon-menu-down');
                }
                else {
                    $('.am-enedis-info-panel-btn>span').removeAttr('class').attr('class', 'glyphicon glyphicon-menu-up');
                }
            }

            _this._enedisRequestSimu = function (event) {
                _this._toogleEnedisProgressBar(true);
                var pvModel = am.solarInstallationModel,
                    panelProps = pvModel._pvPanelModel._properties,
                    roofModel = pvModel._roofModel,
                    roofProps = roofModel._properties,
                    fPeekPower = panelProps.installPeakPower,
                    roofExtents = roofProps.roofExtents,
                    fSiteLat = 0.5 * (roofExtents.lowerLeftCorner[1] + roofExtents.upperRightCorner[1]),
                    fSiteLng = 0.5 * (roofExtents.lowerLeftCorner[0] + roofExtents.upperRightCorner[0]),
                    bProdOnConso = false, bParametric = false,
                    oPayLoad = {
                        "getInfos": 'Enedis_requestGridSimulation',
                        "version_enedis": "v3",
                        "injected_power": (fPeekPower * 0.85 * 1e-3),
                        "latitude": fSiteLat,
                        "longitude": fSiteLng
                    };

                var sSelPhase = $('.enedis-select-triphase-dropdwn').val();
                if (sSelPhase === "triphas") {
                    oPayLoad["triphas"] = true;
                }

                if ($('#am-electricity-production-results-section').is(':hidden')) {
                    bProdOnConso = true;
                }

                // #914 : Activation is_parametric quand le texte résultat est visible.
                var bEnedisTextVisible = ($('.enedis_prod').length != 0 && !$('.enedis_prod').is(':hidden')) ||
                    ($('.enedis_autoconso').length != 0 && !$('.enedis_autoconso').is(':hidden')); 
                if (bEnedisTextVisible) {
                    bParametric = true;
                }

                var bButtonParametricVisible = ($('.enedisInfoPanelBtn-parametric').length > 0 && !($(($('.enedisInfoPanelBtn-parametric'))[0]).is(':hidden'))) ||
                    ($('.enedisInfoPanelBtn-parametric').length > 1 && !($(($('.enedisInfoPanelBtn-parametric'))[1]).is(':hidden')));
                if (bButtonParametricVisible) {
                    bParametric = true;
                    $('.enedisInfoPanelBtn-parametric').hide();
                }

                /*
                if (!($('.enedis_prod').is(':hidden')) || !($('.enedis_autoconso').is(':hidden'))) {
                    bParametric = true;
                }
                if (!($('.enedisInfoPanelBtn-parametric').is(':hidden'))){
                    bParametric = true;
                }
                */
                /*
                if (
                    !($(($('.enedisInfoPanelBtn-parametric'))[0]).is(':hidden')) ||
                    !($(($('.enedisInfoPanelBtn-parametric'))[1]).is(':hidden'))
                ) {
                    bParametric = true;
                    $('.enedisInfoPanelBtn-parametric').hide();
                }
                */

                oPayLoad["prod_on_conso"] = (bProdOnConso ? 1 : 0);
                oPayLoad["is_parametric"] = (bParametric ? 1 : 0);

                _this._enedisUpdateProgressBarRange(100);
                _this._enedisUpdateProgressBar();

                $.ajax({
                    type: "POST",
                    data: oPayLoad,
                    url: "/backend/getInfosBDD.php",
                    dataType: 'json',
                    error: function (u, msg) {
                        _this._toogleEnedisProgressBar(false);
                        _this._enedisPopulateResultDiv(null);
                    },
                    success: function (oReq) {
                        if (!oReq || (!oReq.hasOwnProperty("error") && !oReq.hasOwnProperty("Location"))) {
                            oReq["error"] = am.translator.translate("enedis_api_requesting_err");
                            _this._toogleEnedisProgressBar(false);
                            _this._enedisPopulateResultDiv(null);
                        }
                        else if (!oReq.hasOwnProperty("error")) {
                            var sLocation = oReq["Location"];
                            _this._enedisUpdateProgressBarRange(oReq["X-RemainingTimeHigh"]);
                            _this._enedisProgressInterval = setInterval(function () {
                                _this._enedisUpdateProgressBar();
                            }, 1000);
                            setTimeout(function () {
                                $.ajax({
                                    type: "POST",
                                    data: {
                                        "getInfos": 'Enedis_requestGridSimulationResults',
                                        "version_enedis": "v3",
                                        "request_id": sLocation.substring(sLocation.indexOf("grid_connexion_simulation/v3/LV/") + 32)
                                    },
                                    url: "/backend/getInfosBDD.php",
                                    dataType: 'json',
                                    error: function (u, msg) {
                                        _this._toogleEnedisProgressBar(false);
                                        _this._enedisPopulateResultDiv(null);
                                    },
                                    success: function (oRes) {
                                        if (!oRes) {
                                            oRes["error"] = am.translator.translate("enedis_api_fetching_err");
                                            _this._enedisPopulateResultDiv(null);
                                        }
                                        else if (!oRes.hasOwnProperty("error")) {
                                            oRes["peak_power"] = fPeekPower;
                                            _this._enedisUpdateParamsSimu(oRes);
                                            _this._enedisPopulateResultDiv(oRes);
                                        }
                                        else {
                                            _this._enedisPopulateResultDiv(null);
                                        }
                                        _this._toogleEnedisProgressBar(false);
                                    }
                                });
                            }, oReq["X-RemainingTimeHigh"] * 1000);
                        }
                        else {
                            _this._toogleEnedisProgressBar(false);
                            _this._enedisPopulateResultDiv(null);
                        }
                    }
                });
            };

            // Fill the "share" modal window
            var $shareModalContainer = $('#am-share-modal');
            am.templateManager.fillElementWithTemplate($shareModalContainer, 'share-modal', {}, function($container){
                var $modalContents = $container.find("#am-share-modal-contents");
                $modalContents.modal({
                    backdrop: 'static',
                    show: false
                });

                var $copyLinkButton = $modalContents.find('.btn[data-action="copy-link"]');
                $copyLinkButton.on('click tap', function() {
                    $modalContents.find('#am-link-to-project').get(0).select();
                    document.execCommand("Copy");
                    $copyLinkButton.find('.am-icon').removeClass('am-copy-icon').addClass('am-valid-icon');
                });

                $modalContents.find('#reportRequestForm').on('submit', am.utils.contactFormValidationCallback);
            });

            // Display the "share" modal window
            _this._displayShareModal = function(event) {
                var $modalContents = $shareModalContainer.find("#am-share-modal-contents");
                var link = window.location.href;
                $modalContents.find('#am-link-to-project').val(link);
                $modalContents.find('.btn[data-action="copy-link"] .am-icon').removeClass('am-valid-icon').addClass('am-copy-icon');
                var $sendLinkButton = $modalContents.find('.btn[data-action="send-link"]');
                if ($sendLinkButton.length > 0) {
                    var href = $sendLinkButton.attr('href');
                    $sendLinkButton.attr('href', href.replace('[[LINK]]', encodeURIComponent(link)));
                }

                // var $sendRequest = $modalContents.find('.btn-call-to-action');
                // $sendRequest.html(am.translator.translate('sendRequest'));
                // $sendRequest.prop('disabled', false);

                $modalContents.modal("show");
            };

            _this._exportToPdf = function(event) {
                var $clickedButton = $(this);

                // Disable modal buttons
                $clickedButton.addClass('disabled');
                $('body').addClass('global-loading');

                // Load scripts to generate the PDF
                var scriptsToLoad = ['/vendors/pdfkit/pdfkit.js', '/vendors/pdfkit/blob-stream.js', '/vendors/pdfkit/svgtopdf.js'];
                /*
                var loadScriptPromises = scriptsToLoad.map(function(script) {
                    return $.ajax({
                        url: script,
                        dataType: "script",
                        error: function(jqXHR, textStatus, errorThrown) {
                            console.error('Cannot load script ' + script + ': ' + textStatus);
                        }
                    });
                });
                //*/
                var loadScriptPromises = [];

                // console.log(am.solarInstallationModel.getResult('roofExtents'));
                var _map = _this._map;

                am.solarInstallationModel.getResults().then(function(results) {
                    var oRoofExt = results.roofExtents;
                    var lowerLeftPoint  = _map.latLngToContainerPoint(L.latLng(oRoofExt.lowerLeftCorner[1], oRoofExt.lowerLeftCorner[0]));
                    var upperRightPoint = _map.latLngToContainerPoint(L.latLng(oRoofExt.upperRightCorner[1], oRoofExt.upperRightCorner[0]));
                    var width  = Math.abs(upperRightPoint.x - lowerLeftPoint.x);
                    var height = Math.abs(upperRightPoint.y - lowerLeftPoint.y);
                    var halfSide = Math.max(0.5 * Math.max(width, height), 140); // we take a square picture
                    var upperLeftPoint = [
                        0.5 * (lowerLeftPoint.x + upperRightPoint.x) - halfSide,
                        0.5 * (lowerLeftPoint.y + upperRightPoint.y) - halfSide
                    ];

                    Promise.all(loadScriptPromises).then(function() {
                        var inputs = _this._mainPanelView.getUserInputs();

                        // Build the object to be passed to the PDF template
                        var data = {};
                        Object.keys(_this._dataBindings).forEach(function(key) {
                            var dataInfo = _this._mainPanelView.formatComputationResult(results, _this._dataBindings[key]);
                            data[key] = (fnIsValidValue(dataInfo.value) ? dataInfo.value + '&thinsp;' + dataInfo.units.trim() : '');
                        });

                        data.surfaceType = results.surfaceType;
                        data.currSimulationType = (function(currPageId) {
                            if (currPageId.indexOf("autoconsumption") !== -1) return "electricitySelfConsumption";
                            else if (currPageId.indexOf("hot-water") !== -1)  return "hotWaterProduction";
                            else                                              return "electricityProduction";
                        })(_this._mainPanelView.getCurrentPageId());
                        var currSimulationType = (function(currPageId) {
                            if (currPageId.indexOf("autoconsumption") !== -1) return "autoconsumption";
                            else if (currPageId.indexOf("hot-water") !== -1)  return "hot-water";
                            else                                              return "electricity";
                        })(_this._mainPanelView.getCurrentPageId());

                        var postalAddress = _this._address === null ? $('#am-address-search-field').val() : _this._address;
                        var splitIndex = postalAddress.search(/[^\d](\d{5,})/); // use the postal code as separator
                        data.postalAddress = [
                            postalAddress.substring(0, splitIndex),
                            postalAddress.substring(splitIndex + 1) // we do not capture the comma or space
                        ];

                        data.roofImageData = am.utils.takeLeafletScreenshot(document.getElementById('map'),
                            upperLeftPoint[0] - 10, upperLeftPoint[1] - 10, 2 * halfSide + 20, 2 * halfSide + 20);
                        //data.roofImageData = canvas.toDataURL("image/jpeg"); // toDataURL defaults to png, so we need to request a jpeg, then convert for file download.
                        data.surfacePerIrradiationClass = results.surfacePerIrradiationClass.map(function(val) {return Math.round(val); });
                        data.totalRoofSurface = Math.round(results.roof3DArea);
                        data.pvInstallationSurface = am.translator.formatNumber(Math.round(inputs.panelSurface), 0);
                        data.pvInstallationPower = am.translator.formatNumber(Math.round(inputs.panelSurface * _this._mainPanelView.options.pvPanelYield * 10) / 10, 1);
                        data.thermalInstallationSurface = am.translator.formatNumber(Math.round(parseFloat(data.thermalPanelSurface)), 0);
                        data.nbEtages = inputs.numberOfFloors; // nb etages
                        data.nbPersonnes = inputs.numberOfInhabitants;
                        data.chauffageElectrique = inputs.hasElectricalHeating; //
                        data.chauffeEauElectrique = inputs.hasElectricalBoiler;
                        data.electricityConsumptionSource = inputs.elecConsumptionInfo;
                        data.currentUrl = window.location.href;
                        data.goFurtherUrl = window.location.href
                            .replace(/&previousPanelPageId=[^&]+/, '')
                            .replace(/(panelPageId=)([^&]+)/, '$1am-' + currSimulationType + '-go-further-section');
                        data.dateCourante = new Date().toLocaleDateString("fr", {
                            day: "numeric",
                            month: "long",
                            year: "numeric"
                        });

                        _this._exportPDFAction(data);

                        // Re-enable modal buttons
                        $clickedButton.removeClass('disabled');
                        $('body').removeClass('global-loading');
                    });
                });

                var $modalContents = $shareModalContainer.find("#am-share-modal-contents");
                $modalContents.find('#reportRequestForm').on('submit', am.utils.contactFormValidationCallback);
            };

            _this._exportPDFAction = function(results) {
                // Choose the right PDF template
                var pdfTemplate = "";
                switch(results.currSimulationType) {
                    case 'electricityProduction':
                        pdfTemplate = results.surfaceType === 'parking' ?  'pdf-report-parking-elec-sale' : 'pdf-report-elec-sale';
                        break;
                    case 'electricitySelfConsumption':
                        pdfTemplate = results.surfaceType === 'parking' ?  'pdf-report-parking-elec-autoconso' : 'pdf-report-elec-autoconso';
                        break;
                    case 'hotWaterProduction':
                        pdfTemplate = 'pdf-report-thermal';
                        break;
                    default:
                        throw new Error("Unknown simulation type '" + results.currSimulationType + "'");
                }

                // Fetch the template and convert it to PDF
                am.templateManager.getTemplateAsText(pdfTemplate, results).then(function(svgContents) {
                    // Open PDF document
                    var doc = new PDFDocument({ layout: "portrait", size: "A4" });

                    // Fill the PDF document
                    SVGtoPDF(doc, svgContents, 0, 0);

                    // Sauvegarde le document sous forme de fichier
                    var stream = doc.pipe(blobStream());
                    stream.on('finish', function(fd) {
                        var url = stream.toBlobURL('application/pdf');

                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.href = url;
                        a.download = am.translator.translate("rapport.pdf");
                        a.click();
                        document.body.removeChild(a);
                    });

                    // Close PDF document
                    doc.end();
                });
            };

            // Replace place holders with their respective contents
            _this._setHrefInContactButton = function(event) {
                var $element = $(event.target).closest('a');
                var href = $element.attr('href');
                var hrefBackup = href;
                var currUrl = window.location;
                var urlParts = am.utils.getUrlParameters(currUrl.search);
                if (urlParts.hasOwnProperty('panelPageId') && urlParts.hasOwnProperty('previousPanelPageId')) {
                    urlParts.panelPageId = urlParts.previousPanelPageId;
                    delete urlParts.previousPanelPageId;
                }
                href = href.replace('[[LINK]]', encodeURIComponent(currUrl.origin + currUrl.pathname + '?' + am.utils.combineUrlParameters(urlParts)));
                href = href.replace('[[ADDRESS]]', encodeURIComponent($(".am-address").text().trim()));
                $element.attr('href', href);
                setTimeout(function() { // restore initial state for next call
                    $element.attr('href', hrefBackup);
                }, 500);
            };

            // Hide or show the correct input fields depending on whether the user knows his annual electricty consumption
            // or not...
            _this._toggleElecConsumptionInputs = function(event) {
                var elecConsumptionInfo = $(this).attr('value');
                var $formGroups = $('.am-user-input-block .form-group');
                $formGroups.filter('[data-for-elec-consumption-info]').addClass('hidden');
                $formGroups.filter('[data-for-elec-consumption-info=' + elecConsumptionInfo + ']').removeClass('hidden');
            };

            // Parse the CSV provided by the user and correct the electricity consumption curve
            _this._handleElecConsumptionProfileLoaded = function(event) {
                var inputElement = this;
                var inputFile = inputElement.files[0];
                var reader = new FileReader();
                reader.onload = function(event) {
                    var csvFileContents = event.target.result;
                    var userType = _this._mainPanelView.getUserProfile();
                    try {
                        var consumptionProfile = am.utils.parseElectricityConsumptionFile(csvFileContents, false);
                        var params = am.solarInstallationModel._pvPanelModel._params;
                        if (!params.hasOwnProperty('profiles')) {
                            params.profiles = {};
                        }
                        if (!params.profiles.hasOwnProperty(userType)) {
                            params.profiles[userType] = {};
                        }
                        params.profiles[userType].userProfile = {
                            values: consumptionProfile,
                            somme: consumptionProfile.reduce(function(sum, val) { return isNaN(val) ? sum : sum + val; }, 0)
                        };
                        _this._updateResults().then(function(res) {
                            $('#btn_am-electricity-autoconsumption-results-section').prop('disabled', false);
                        });
                    } catch (error) {
                        var message = error.message.indexOf('unrecognized format') !== -1 ? am.translator.translate('csvElecConsumptionFileBadFormat') :
                                      error.message.indexOf('complete year') !== -1 ? am.translator.translate('csvElecConsumptionFileIncomplete') :
                                      am.translator.translate('csvElecConsumptionFileUnknownError');
                        am.utils.displayMessageNextToElement(inputElement, 'error-message', { message: message }, 'bottom', {
                            customClass: 'am-dropdown-error-message',
                            duration: 3000
                        })
                    }

                };
                reader.readAsText(inputFile);
            };

            // Color the div's displaying the solar potential classes
            am.utils.colorSolarPotentialDivs(panelElement, null, _this._irradiationClasses);

            panelElement.find('.input:not(.input-file), .checkbox').on('click tap', _this._updateCheckbox);
            panelElement.find('input:not(.am-solar-panel-surface-slider)').on('change', function(e) {
                _this._handleFormChange(e);
            });
            panelElement.find('.am-solar-panel-surface-slider').on('slide change', function(e) {
                _this._handleFormChange(e);
            });
            panelElement.find('.am-solar-panel-surface-slider').on('slide change', _this._limitSliderRange);
            panelElement.find('.am-solar-panel-surface-slider').on('slide change', _this._displayWaitModal);
            panelElement.find('button:not(.btn-close)').on('click tap', _this._handlePageChange);//#2414 not(.btn-close) pour ne pas lancer un calcul inutile a la fermeture 
            panelElement.find('.btn-close').on('click tap', _this._closePanel);
            panelElement.find('.btn[data-action="share-project"]').on('click tap', _this._displayShareModal);
            panelElement.find('.btn[data-action="export-pdf"]').on('click tap', _this._exportToPdf);
            panelElement.find('#am-user-profiles label').on('click tap', _this._toggleSimulationButtons);
            panelElement.find('.am-contact-administration').on('click tap', _this._setHrefInContactButton);
            panelElement.find('#am-elec-consumption input[type=radio]').on('change', _this._toggleElecConsumptionInputs);
            panelElement.find('#am-elec-consumption-file').on('change', _this._handleElecConsumptionProfileLoaded);
            panelElement.find('.open-contact-form-modal').on('click tap', function(event) {
                event.preventDefault();
                var targetModalId = $(this).attr('data-target-modal-id');
                var $targetModal = $((targetModalId[0] === '#' ? '' : '#') + targetModalId);
                $targetModal.find('.am-contact-request-form').attr('data-contact-reason', $(this).attr('data-contact-reason'));
                $targetModal.modal({
                    backdrop: 'static',
                    show: true
                });
            });

            panelElement.find('.btn-enedis').on('click tap', _this._enedisRequestSimu);
            panelElement.find('.enedis-more-info-link').on('click tap', _this._enedisShowMoreInfoTip);

            $(panelElement.find('.am-enedis-info-panel-btn')[0]).on('click tap', _this._toggleEnedisPanel);
            $(panelElement.find('.am-enedis-info-panel-btn')[1]).on('click tap', _this._toggleEnedisPanel);

            am.eventManager.register('knob_changed', function(e) {
                _this._handleFormChange(e);
            }, _this);
        });
    };

    module.InfoPanelController.prototype._initializeRoofPanelView = function() {
        var self = this;
        if (this._config.displayRoofPanel) {
            am.templateManager.getTemplateAsHTMLElements('small-side-panel', {
                irradiationClasses : self._irradiationClasses,
                displayPublicFooter: false,
                compactForm: true
            }).then(function(htmlElements) {
                self._roofPanelView.setContents(htmlElements[0]);
                am.utils.colorSolarPotentialDivs($(self._roofPanelView.getContainer()), "to top", self._irradiationClasses);
            });
        }
    };

    module.InfoPanelController.prototype._displayInfoOnFeature = function(featureInfos) {
        var _this = this;
        g_fNetConnectionPriceTTC = null;
        $(".enedis_request_form").show();
        $(".enedis_request_form_results").hide();
        _this._featureId = featureInfos.buildingId;

        var promise = new Promise(function(resolve, reject) {
            // Update the panel contents
            if (am.utils.isParameterInUrl('panelPageId')) {
                var urlParams = am.utils.getUrlParameters();
                _this._mainPanelView.setUserInputs(urlParams).then(function () {
                    _this._updateResults().then(function(res) {
                        _this._mainPanelView.displayPage(urlParams.panelPageId, urlParams.previousPanelPageId);
                        resolve(res);
                    });
                });
            } else if (featureInfos.reinitializePanel) {
                _this._updateResults().then(function(res) { // first round of computations to get the optimal surface
                    _this._mainPanelView.displayPage("am-home-section");
                    var userInputs = _this._mainPanelView.getUserInputs();
                    userInputs.panelSurface = res.optimalSurfaceForElectricitySale;
                    _this._mainPanelView.setUserInputs(userInputs).then(function () {
                        _this._updateResults().then(function(res2) { // second round of computations to set the optimal surface
                            resolve(res2);
                        });
                    });
                });
            } else {
                _this._updateResults().then(function(res) {
                    resolve(res);
                });
            }
        });
        promise.then(function(results) {
            // Add an attribute to the panel container indicating the surface type (roof, parking or ground), another
            // one indicating the electrical constraints, and an additional one indicating whether the Enedis functionality
            // should be activated or not.
            am.solarInstallationModel.getResults().then(function(results) {
                _this._mainPanelView.getPanelElement().then(function($panelContainer) {
                    $panelContainer.attr('data-surface-type', results.surfaceType.toLowerCase());
                    $panelContainer.attr('data-connexion-constraints', results.electricalNetworkConnexionContraints);
                    var activateEnedisFunctionality = true;
                    if (_this._config.restrictEnedisFunctionality !== undefined && Array.isArray(_this._config.restrictEnedisFunctionality.cityCodes) &&
                        _this._config.restrictEnedisFunctionality.include !== undefined && results.cityCode !== undefined) {
                        var cityCodeMatches = _this._config.restrictEnedisFunctionality.cityCodes.indexOf(results.cityCode) !== -1;
                        activateEnedisFunctionality = (_this._config.restrictEnedisFunctionality.include && cityCodeMatches) ||
                                                      (!_this._config.restrictEnedisFunctionality.include && !cityCodeMatches);
                    }
                    $panelContainer.attr('data-activate-enedis-functionnality', '' + activateEnedisFunctionality);
                });
                var $smallPanel = $(_this._roofPanelView.getContainer()).children('.am-panel-contents');
                $smallPanel.attr('data-surface-type', results.surfaceType.toLowerCase());
                $smallPanel.attr('data-connexion-constraints', results.electricalNetworkConnexionContraints);
            });

            // Update the slider limits
            _this._updateSlider(true, !am.utils.isParameterInUrl('panelPageId'), results);

            // Set the dimensions of the div's
            var sliderMinValue = results.minAvailablePanelSurface.pv;
            var sliderMaxValue = results.maxAvailablePanelSurface.pv;
            var surfaces = results.surfacePerIrradiationClass.slice(); // shallow copy of array
            var cumulatedSurface = 0;
            for (var iSurf = surfaces.length - 1; iSurf >= 0; --iSurf) {
                var newCumulatedSurface = cumulatedSurface + surfaces[iSurf];
                if (cumulatedSurface < sliderMinValue) {
                    surfaces[iSurf] = Math.max(0, newCumulatedSurface - sliderMinValue);
                }
                if (newCumulatedSurface > sliderMaxValue) {
                    surfaces[iSurf] = Math.max(0, sliderMaxValue - cumulatedSurface);
                }
                cumulatedSurface = newCumulatedSurface;
            }
            var availableRoofArea = surfaces.reduce(function(a, b) {return a + b;});
            var $panelElement = $(_this._mainPanelView.getContainer());
            var nBreaks = surfaces.length - 1;
            $panelElement.find('.am-surface-block-wrapper').each(function(unusedParam, wrapper) {
                $(wrapper).find('.am-surface-block').each(function(index, element) {
                    var width = surfaces[nBreaks - index] / availableRoofArea * 100;
                    var $element = $(element);
                    if (width < 1e-10) {
                        $element.hide();
                    } else {
                        $element.css('flex', width + '');
                        $element.show();
                    }
                });
            });

            // Display the warning about the architectural constraints
            if (results.hasOwnProperty("architecturalConstraints") && results.architecturalConstraints !== undefined && results.architecturalConstraints % 32 > 0) {
                $("#am-architectural-constraints-warning-block").removeClass("hidden");
            } else {
                $("#am-architectural-constraints-warning-block").addClass("hidden");
            }

            // display the panel
            _this._mainPanelView.show();

            // Display the side panel presenting information about the selected roof, if required
            if (_this._config.displayRoofPanel) {
                if(!featureInfos.address){
                    featureInfos.address = _this._address;
                }
                _this._updateRoofPanelInfos(featureInfos.address);
                _this._roofPanelView.show();
            }

            // Send an event to inform the main controller about the space which will be occupied by the panel after it
            // has completely expanded
            var reservedSpace = _this._mainPanelView.reservedMapSpace();
            if (_this._config.displayRoofPanel) {
                reservedSpace[2] = Math.max(reservedSpace[2], _this._roofPanelView.getDimensions()[1]);
            }
            am.eventManager.trigger('info_panel_visible', {
                reservedSpace: reservedSpace,
                featureBounds: featureInfos.buildingBounds,
                featureCenter: featureInfos.pointLocation
            });
        });
    };

    module.InfoPanelController.prototype._updateSlider = function(updateResults, optimizePanelSurface, results) {
        var self = this;
        updateResults = (updateResults === undefined) ? true : updateResults;
        optimizePanelSurface = (optimizePanelSurface === undefined) ? true : optimizePanelSurface;
        if (results) {
            // Set the slider range
            self._mainPanelView.options.pvPanelYield = results.pvPanelYield;
            self._mainPanelView.setSliderRange(6, results.maxAvailablePanelSurface.pv, 'pv');
            self._mainPanelView.setSliderRange(2, results.maxAvailablePanelSurface.thermal, 'thermal');

            // Update the results if required
            if (updateResults) {
                var userInputs = self._mainPanelView.getUserInputs();
                if (optimizePanelSurface) {
                    userInputs.panelSurface = results.optimalSurfaceForElectricitySale;
                    self._mainPanelView.setSliderValue(userInputs.panelSurface, 'pv'); // set the slider to the optimal surface
                }
            }
        }
    };

    module.InfoPanelController.prototype._updateRoofPanelInfos = function(address) {
        var self = this;
        this._address = address;

        if (this._config.displayRoofPanel) {
            var $container = $(self._roofPanelView.getContainer());

            am.templateManager.getTemplateAsHTMLElements('small-side-panel', {
                irradiationClasses : self._irradiationClasses,
                address: address,
                displayPublicFooter: false,
                compactForm: true
            }).then(function(htmlElements) {
                self._roofPanelView.setContents(htmlElements[0]);
                am.utils.colorSolarPotentialDivs($container, "to top", self._irradiationClasses);
                am.utils.updateSolarPotentialDivs($container, true);
            });
        }
    };

    module.InfoPanelController.prototype._updateResults = function() {
        var _this = this;

        var userInputs = this._mainPanelView.getUserInputs();
        var currPeakPower = userInputs.panelSurface * this._mainPanelView.options.pvPanelYield;
        if (currPeakPower >= this._config.maxAllowedInstallationPower) {
            $(".show-if-above-100-kWc").removeClass("hidden");
            $(".hide-if-above-100-kWc").addClass("hidden");
        } else {
            $(".show-if-above-100-kWc").addClass("hidden");
            $(".hide-if-above-100-kWc").removeClass("hidden");
        }
        if (currPeakPower >= 9) {
            $(".show-if-above-9-kWc").removeClass("hidden");
            $(".hide-if-above-9-kWc").addClass("hidden");
        } else {
            $(".show-if-above-9-kWc").addClass("hidden");
            $(".hide-if-above-9-kWc").removeClass("hidden");
        }

        return new Promise(function(resolve, reject) {
            am.solarInstallationModel.setUserInfos(userInputs).then(function() {
                return am.solarInstallationModel.getResults();
            }).then(function(results) {
                resolve(results);
            });
        }).then(function(_results) {
            _this._mainPanelView.setComputationResults(_results, _this._dataBindings);
            return _results;
        });
    };

    module.InfoPanelController.prototype._hideFeatureInfo = function() {
        // Send an event to inform the main controller about the space which will be freed by the panel after it
        // has been completely hidden
        am.eventManager.trigger('info_panel_hidden', {
            reservedSpace: this._mainPanelView.reservedMapSpace()
        });

        // Hide the panel
        this._mainPanelView.hide();
        if (this._config.displayRoofPanel) {
            this._roofPanelView.hide();
        }
    };

    module.InfoPanelController.prototype._getPageUrl = function(oldPageId, newPageId) {
        var urlComponents = this._mainPanelView.getUserInputs();
        if (oldPageId && newPageId) {
            urlComponents.panelPageId = newPageId;
            urlComponents.previousPanelPageId = oldPageId;
        }
        return urlComponents;
    };

    module.InfoPanelController.prototype._handleComputationStart = function(roofSurface) {
        // Display progress information only for large roofs
        if (roofSurface >= this._config.minRoofSurfaceForWaitingModal) {
            // $('.am-irradiation-computation-in-progress').show();
        }
    };

    module.InfoPanelController.prototype._handleComputationEnd = function() {
        $('.am-irradiation-computation-in-progress').hide();
    };

    module.InfoPanelController.prototype._setAddress = function(address, postal_code, locality) {
        this._address = address;
        this._postal_code = postal_code;
        this._locality = locality;
    };

    return module;

})(am || {});


//=============================================
// AM.UTILS NAMESPACE
//=============================================
am.utils = (function(module) {

    // Use strict mode
    'use strict';

    /**
     * Returns a new instance of class am.InfoPanelController
     *
     * @param {Object} mainController - Reference to the main controller of the application
     * @param {Object} config - Configuration object to be passed to the constructor of class am.InfoPanelController
     * @return {am.InfoPanelController} - New instance of class am.InfoPanelController 
     */
    module.infoPanelController = function(mainController, config) {
        var ctrl = new am.InfoPanelController();
        ctrl.init(mainController, config);
        return ctrl;
    };

    return module;

})(am.utils || {});